module.exports = __webpack_public_path__ + "static/media/12UNCTAD13.9a947906.jpg";